import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "./cn.js";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={cn("yatta-input", className)} {...props} />
  ),
);
Input.displayName = "Input";
